<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">导入结果</h2>
        <el-button type="primary" size="mini" :disabled="auths.indexOf(2) < 0"  round @click="downloadTmp">下载模板</el-button>
        <el-button type="primary" size="mini" :disabled="auths.indexOf(2) < 0" round @click="uploadDialog=true">上传数据</el-button>
      </div>
      <div class="common-box-body">
        <el-table ref="multipleTable" :data="tableData" size="small" v-loading="listLoading"  element-loading-text="拼命加载中" border style="width: 100%" header-row-class-name="table-header">
          <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
          <el-table-column prop="projectCode" label="项目编号" align="center" min-width="155"></el-table-column>
          <el-table-column prop="projectName" label="项目名" align="center" min-width="150"></el-table-column>
          <el-table-column prop="startTime" label="项目时间" width="160" align="center" :formatter="formatDate"></el-table-column>
          <el-table-column prop="idCard" label="身份证" width="160" align="center" :formatter="formatIdCard"></el-table-column>
          <!-- <el-table-column prop="qcScore" label="QC评分" align="center"></el-table-column> -->
          <el-table-column prop="trainScore" label="培训得分" align="center"></el-table-column>
          <el-table-column prop="customerScore" label="客户评分" align="center"></el-table-column>
          <el-table-column prop="customerStar" label="客户星级" align="center"></el-table-column>
          <el-table-column prop="projectScore" label="项目组评分" align="center"></el-table-column>
          <el-table-column prop="jobRate" label="活动在岗率" align="center"></el-table-column>
          <el-table-column prop="jobScore" label="活动在岗成绩" align="center"></el-table-column>
          <el-table-column prop="salesVolume" label="实际销量" align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" :formatter="formatDate"></el-table-column>
        </el-table>

        <el-pagination class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="slot, total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-row>
    <!--上传对话框-->
    <el-dialog class="dialog" title="上传评分数据" :visible.sync="uploadDialog" width="500px" center>
      <div class="dialog-body">
        <el-upload
          action="/rest/upDownload/importScore"
          :before-upload="handlePreview"
          :on-success='handleSuccess'
          :on-error='handleError'
          :show-file-list="false"
          >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-btn" size="small" @click="uploadDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '../../common/js/util.js'
import moment from 'moment'
export default {
  data() {
    return {
      pageNo: 1,
      pageSize: 20,
      total: null,
      formData: {
        pageNo: 1,
        pageSize: 20
      },
      tableData: [],
      uploadDialog: false,
      listLoading: false,
      // 页面内权限
      auths:[],
    };
  },
  mounted() {
    this.getData();
    this.getAuth()
  },
  methods: {
    formatIdCard(row, column, cellValue){
      if(sessionStorage.getItem('user') == 'admin1' || sessionStorage.getItem('user') == 'tinashi'){
        return cellValue
      } else {
        return utils.plusXing(cellValue,6,4)
      }

    },
    getData() {
      this.listLoading = true
      this.$http({
        method: "POST",
        url: "/rest/projectScore/getProjectScoreLog",
        data: this.formData
      }).then(res => {
        this.listLoading = false
        this.tableData = res.data;
      }).catch(err => {
        utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
			  this.listLoading = false
	    });

      this.$http({
        method: "POST",
        url: "/rest/projectScore/searchCount"
      }).then(res => {
        this.total = res.data;
      }).catch(err => {
        utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
	    });
    },
    getAuth(){
      this.$http({
        method:"GET",
        url:"/rest/sysUser/getSysUserWebAuth",
        params:{
          webId:18,
          sysUserId:sessionStorage.getItem("sysUserId")
        }
      }).then(res=>{
        let data = res.data
        data.forEach(item=>{
          this.auths.push(item.auth)
        })
      }).catch(err => {
        utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
	    })
    },
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    downloadTmp() {
      this.$http({
        method: "POST",
        url: "/rest/upDownload/downloademplate"
      }).then(res => {
        if (res && res.data && (res.data.code == 0 || res.data.code == null)) {
          location.href = utils.returnUrlHead() + res.data.message;
        }
      }).catch(err => {
        utils.myNotify(this,'error',err.response,'查询失败，请稍后重试')
	    });
    },
    handleSuccess(response, file, fileList) {
      if (response.message == '导入成功') {
        this.getData()
      }
      this.$alert(response.message, '提示', {
        dangerouslyUseHTMLString: true,
        callback(){
          this.uploadDialog = false;
        }
      })
    },
    handlePreview(file) {
      // return this.$confirm("您确定上传评分数据吗？", "警告", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消"
      // })
    },
    handleError(err, response, file) {
      let msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, '提示', {
        dangerouslyUseHTMLString: true,
        callback: action => {
          this.uploadDialog = false;
        }
      })
    },

    formatDate (row, column, cellValue) {
      if (cellValue) {
        return moment(cellValue).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
  }
};
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/views/personnelCenter/importScore.vue